import { render, staticRenderFns } from "./billing.vue?vue&type=template&id=22d97e04&scoped=true"
import script from "./billing.vue?vue&type=script&lang=ts"
export * from "./billing.vue?vue&type=script&lang=ts"
import style0 from "./billing.vue?vue&type=style&index=0&id=22d97e04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d97e04",
  null
  
)

export default component.exports